import { AfterViewInit, Component, effect, HostListener, inject, input, OnInit } from '@angular/core';
import Chart, { ChartData } from 'chart.js/auto';
import { v4 as uuidv4 } from 'uuid';
import { LanguageService } from '../../../../services/translations/language.service';

@Component({
  selector: 'app-bar-chart',
  imports: [],
  templateUrl: './bar-chart.component.html',
  styleUrl: './bar-chart.component.css'
})
export class BarChartComponent implements AfterViewInit {

  chart: any = [];
  canvasId: string = uuidv4();
  languageService = inject(LanguageService);

  constructor() {
    effect(() => {
      const isRtl = this.languageService.isRtl();
      if (this.chart && this.chart.options?.scales) {
        this.chart.options.scales['x'].reverse = isRtl;
        this.chart.options.scales['y'].position = isRtl ? 'right' : 'left';
        this.chart.update();
      }
    });
  }


  labels = input<string[]>(["1", "5", "10", "15", "20", "25", "30"]);
  datasets = input<ChartData["datasets"]>([
    {
      label: 'المبيعات',
      data: [1000, 800, 1400, 900, 700, 900, 700],
      backgroundColor: '#363636',
      borderRadius: 7,
      barThickness: 20,
    }
  ]);

  beginAtZero = input<boolean>(true);


  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (this.chart.length == 0)
      return;

    this.chart.resize();
  }


  ngAfterViewInit(): void {

    const isRtl = this.languageService.isRtl();

    this.chart = new Chart(this.canvasId, {
      type: 'bar',
      data: {
        labels: this.labels(),
        datasets: this.datasets(),
      },
      options: {
        plugins: {
          legend: {
            display: false
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            reverse: isRtl,
            grid: {
              display: false,
              drawTicks: false,
            },
            ticks: {
              color: '#8E8E8E',
              display: true,
              font: {
                // family: 'Poppins',
                weight: 500,
              },
            },
            border: {
              display: false,
            },
          },
          y: {
            position: isRtl ? 'right' : 'left',
            beginAtZero: this.beginAtZero(),
            grid: {
              display: true,
              color: '#f9f9f9',
            },
            ticks: {
              color: '#8E8E8E',
              display: true,
              font: {
                // family: 'Poppins',
                weight: 500,
              },
              callback: function (value, index, values) {
                if (Number(value) >= 10000)
                  return Number(value) / 1000 + 'k';

                return value;
              }
            },
            border: {
              display: false,
            }
          }
        }
      }
    });
  }
}
